import { __assign, __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-42bacbcf"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "wrap" };
var _hoisted_2 = { class: "content" };
var _hoisted_3 = ["onClick"];
var _hoisted_4 = { class: "product-title" };
var _hoisted_5 = /*#__PURE__*/ _createTextVNode("待支付");
var _hoisted_6 = /*#__PURE__*/ _createTextVNode("待签字");
var _hoisted_7 = /*#__PURE__*/ _createTextVNode("待绑定信息");
var _hoisted_8 = /*#__PURE__*/ _createTextVNode("待发快递");
var _hoisted_9 = /*#__PURE__*/ _createTextVNode("待出检测报告");
var _hoisted_10 = /*#__PURE__*/ _createTextVNode("已完成");
var _hoisted_11 = /*#__PURE__*/ _createTextVNode("申请退款");
var _hoisted_12 = /*#__PURE__*/ _createTextVNode("退款完成");
var _hoisted_13 = /*#__PURE__*/ _createTextVNode("订单取消");
var _hoisted_14 = /*#__PURE__*/ _createTextVNode("快递取消");
var _hoisted_15 = /*#__PURE__*/ _createTextVNode("待快递取件");
var _hoisted_16 = /*#__PURE__*/ _createTextVNode("呼叫快递失败");
var _hoisted_17 = /*#__PURE__*/ _createTextVNode("快递已取件");
var _hoisted_18 = /*#__PURE__*/ _createTextVNode("套餐价格");
var _hoisted_19 = /*#__PURE__*/ _createTextVNode("受检姓名");
var _hoisted_20 = /*#__PURE__*/ _createTextVNode("样本编号");
var _hoisted_21 = /*#__PURE__*/ _createTextVNode("下单时间");
var _hoisted_22 = { style: { textAlign: 'right' } };
var _hoisted_23 = /*#__PURE__*/ _createTextVNode("绑定信息");
var _hoisted_24 = /*#__PURE__*/ _createTextVNode("不发快递");
var _hoisted_25 = /*#__PURE__*/ _createTextVNode("发快递");
var _hoisted_26 = /*#__PURE__*/ _createTextVNode("重新呼叫");
var _hoisted_27 = /*#__PURE__*/ _createTextVNode("预览报告");
var _hoisted_28 = /*#__PURE__*/ _createTextVNode(" 分配医生 ");
import { ref } from "vue";
import { requerySalesmanOrderList, skipExpress } from "@/api";
import { debounce } from "@/utils";
import router from "@/router";
import { Toast } from "vant";
import ReviewReport from "@/components/reviewReport.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'MyOrders',
    setup: function (__props) {
        var _this = this;
        var loading = ref(false);
        var finished = ref(false);
        var productsList = ref([]);
        var onLoad = function () {
            console.log("加载中");
            debounceGetOrdersList();
            loading.value = false;
        };
        var viewDetails = function (orderId, orderStatus, hasBind) {
            if (orderStatus === 1 || !hasBind) {
                return;
            }
            router.push("/salesman-order-details?orderId=" + orderId);
        };
        var pageParams = {
            pageIndex: 0,
            pageSize: 10,
        };
        var getOrdersList = function () { return __awaiter(_this, void 0, void 0, function () {
            var res, records;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        pageParams.pageIndex++;
                        return [4 /*yield*/, requerySalesmanOrderList(pageParams.pageIndex).catch(function () { return (finished.value = true); })];
                    case 1:
                        res = _c.sent();
                        loading.value = false;
                        if (res.code === 200) {
                            // 订单状态 1 创建订单，2 支付完成 3 绑定完成 4 快递中 5 待初检报告 6已完成 7 退款申请 8 退款完成
                            if (pageParams.pageIndex === 1) {
                                productsList.value = [];
                            }
                            records = (_a = res.data.records) === null || _a === void 0 ? void 0 : _a.map(function (item) {
                                var _a;
                                return __assign(__assign({}, item), { orderPrice: (_a = item.orderPrice) === null || _a === void 0 ? void 0 : _a.toFixed(2) });
                            });
                            productsList.value = (_b = productsList.value) === null || _b === void 0 ? void 0 : _b.concat(records);
                            if (res.data.pages <= pageParams.pageIndex) {
                                finished.value = true;
                            }
                        }
                        else {
                            Toast(res.message || "网络错误-09");
                            finished.value = true;
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        var debounceGetOrdersList = debounce(getOrdersList, 300);
        // 预览报告
        var reportVisible = ref(false);
        var reportUrl = ref("");
        var handleCancel = function () {
            reportVisible.value = false;
            reportUrl.value = "";
        };
        // 跳过快递
        var handleSkipExpress = function (item) { return __awaiter(_this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        loading.value = true;
                        pageParams.pageIndex = 0;
                        return [4 /*yield*/, skipExpress({
                                orderId: item.orderId,
                            }).finally(function () {
                                loading.value = false;
                            })];
                    case 1:
                        res = _a.sent();
                        if (res.code === 200) {
                            finished.value = false;
                            debounceGetOrdersList();
                        }
                        else {
                            Toast(res.message || "网络错误-09");
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        var handleDepartDoctor = function () {
            // 分配医生
        };
        return function (_ctx, _cache) {
            var _component_van_icon = _resolveComponent("van-icon");
            var _component_van_nav_bar = _resolveComponent("van-nav-bar");
            var _component_van_tag = _resolveComponent("van-tag");
            var _component_van_col = _resolveComponent("van-col");
            var _component_van_row = _resolveComponent("van-row");
            var _component_van_divider = _resolveComponent("van-divider");
            var _component_van_button = _resolveComponent("van-button");
            var _component_van_list = _resolveComponent("van-list");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_van_nav_bar, {
                    title: "我的订单",
                    onClickLeft: _cache[0] || (_cache[0] = function ($event) { return (_unref(router).go(-1)); })
                }, {
                    left: _withCtx(function () { return [
                        _createVNode(_component_van_icon, {
                            color: "rgba(0,0,0,0.9)",
                            name: "arrow-left",
                            size: "24"
                        })
                    ]; }),
                    _: 1
                }),
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_van_list, {
                        style: _normalizeStyle({ marginTop: '0.32rem' }),
                        loading: loading.value,
                        "onUpdate:loading": _cache[1] || (_cache[1] = function ($event) { return ((loading).value = $event); }),
                        finished: finished.value,
                        "finished-text": "没有更多了",
                        onLoad: onLoad
                    }, {
                        default: _withCtx(function () { return [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productsList.value, function (item) {
                                return (_openBlock(), _createElementBlock("div", {
                                    class: "product-item",
                                    key: item.orderNo,
                                    onClick: function ($event) { return (viewDetails(item.orderId, item.orderStatus, item.hasBind)); }
                                }, [
                                    _createElementVNode("div", {
                                        style: _normalizeStyle({ flex: 'auto', padding: '0.32rem' })
                                    }, [
                                        _createElementVNode("p", _hoisted_4, [
                                            _createTextVNode(_toDisplayString(item.skuName) + " ", 1),
                                            (item.orderStatus === 1)
                                                ? (_openBlock(), _createBlock(_component_van_tag, {
                                                    key: 0,
                                                    style: _normalizeStyle({ marginLeft: '0.2rem' }),
                                                    type: "warning"
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_5
                                                    ]; }),
                                                    _: 1
                                                }, 8, ["style"]))
                                                : _createCommentVNode("", true),
                                            (item.hasBind === false && item.orderStatus === 2)
                                                ? (_openBlock(), _createBlock(_component_van_tag, {
                                                    key: 1,
                                                    style: _normalizeStyle({ marginLeft: '0.2rem' }),
                                                    type: "danger"
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_6
                                                    ]; }),
                                                    _: 1
                                                }, 8, ["style"]))
                                                : _createCommentVNode("", true),
                                            (item.hasBind === false &&
                                                (item.orderStatus === 12 || item.orderStatus === 3))
                                                ? (_openBlock(), _createBlock(_component_van_tag, {
                                                    key: 2,
                                                    style: _normalizeStyle({ marginLeft: '0.2rem' }),
                                                    type: "danger"
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_7
                                                    ]; }),
                                                    _: 1
                                                }, 8, ["style"]))
                                                : _createCommentVNode("", true),
                                            (item.orderStatus === 3)
                                                ? (_openBlock(), _createBlock(_component_van_tag, {
                                                    key: 3,
                                                    style: _normalizeStyle({ marginLeft: '0.2rem' }),
                                                    type: "danger"
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_8
                                                    ]; }),
                                                    _: 1
                                                }, 8, ["style"]))
                                                : _createCommentVNode("", true),
                                            (item.orderStatus === 5 || item.orderStatus === 11)
                                                ? (_openBlock(), _createBlock(_component_van_tag, {
                                                    key: 4,
                                                    style: _normalizeStyle({ marginLeft: '0.2rem' }),
                                                    type: "danger"
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_9
                                                    ]; }),
                                                    _: 1
                                                }, 8, ["style"]))
                                                : _createCommentVNode("", true),
                                            (item.orderStatus === 6)
                                                ? (_openBlock(), _createBlock(_component_van_tag, {
                                                    key: 5,
                                                    style: _normalizeStyle({ marginLeft: '0.2rem' }),
                                                    type: "success"
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_10
                                                    ]; }),
                                                    _: 1
                                                }, 8, ["style"]))
                                                : _createCommentVNode("", true),
                                            (item.orderStatus === 7)
                                                ? (_openBlock(), _createBlock(_component_van_tag, {
                                                    key: 6,
                                                    style: _normalizeStyle({ marginLeft: '0.2rem' }),
                                                    type: "danger"
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_11
                                                    ]; }),
                                                    _: 1
                                                }, 8, ["style"]))
                                                : _createCommentVNode("", true),
                                            (item.orderStatus === 8)
                                                ? (_openBlock(), _createBlock(_component_van_tag, {
                                                    key: 7,
                                                    style: _normalizeStyle({ marginLeft: '0.2rem' }),
                                                    type: "success"
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_12
                                                    ]; }),
                                                    _: 1
                                                }, 8, ["style"]))
                                                : _createCommentVNode("", true),
                                            (item.orderStatus === 10)
                                                ? (_openBlock(), _createBlock(_component_van_tag, {
                                                    key: 8,
                                                    style: _normalizeStyle({ marginLeft: '0.2rem' }),
                                                    type: "danger"
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_13
                                                    ]; }),
                                                    _: 1
                                                }, 8, ["style"]))
                                                : _createCommentVNode("", true),
                                            (item.orderStatus === 4 || item.orderStatus === 4)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                                                    (item.sendStatus === 0)
                                                        ? (_openBlock(), _createBlock(_component_van_tag, {
                                                            key: 0,
                                                            style: _normalizeStyle({ marginLeft: '0.2rem' }),
                                                            type: "danger"
                                                        }, {
                                                            default: _withCtx(function () { return [
                                                                _hoisted_14
                                                            ]; }),
                                                            _: 1
                                                        }, 8, ["style"]))
                                                        : _createCommentVNode("", true),
                                                    (item.sendStatus === 1)
                                                        ? (_openBlock(), _createBlock(_component_van_tag, {
                                                            key: 1,
                                                            style: _normalizeStyle({ marginLeft: '0.2rem' }),
                                                            type: "warning"
                                                        }, {
                                                            default: _withCtx(function () { return [
                                                                _hoisted_15
                                                            ]; }),
                                                            _: 1
                                                        }, 8, ["style"]))
                                                        : _createCommentVNode("", true),
                                                    (item.sendStatus === 2)
                                                        ? (_openBlock(), _createBlock(_component_van_tag, {
                                                            key: 2,
                                                            style: _normalizeStyle({ marginLeft: '0.2rem' }),
                                                            type: "danger"
                                                        }, {
                                                            default: _withCtx(function () { return [
                                                                _hoisted_16
                                                            ]; }),
                                                            _: 1
                                                        }, 8, ["style"]))
                                                        : _createCommentVNode("", true),
                                                    (item.sendStatus === 3)
                                                        ? (_openBlock(), _createBlock(_component_van_tag, {
                                                            key: 3,
                                                            style: _normalizeStyle({ marginLeft: '0.2rem' }),
                                                            type: "danger"
                                                        }, {
                                                            default: _withCtx(function () { return [
                                                                _hoisted_17
                                                            ]; }),
                                                            _: 1
                                                        }, 8, ["style"]))
                                                        : _createCommentVNode("", true)
                                                ], 64))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _createVNode(_component_van_row, { class: "order-field" }, {
                                            default: _withCtx(function () { return [
                                                _createVNode(_component_van_col, {
                                                    class: "order-field-title",
                                                    span: "6"
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_18
                                                    ]; }),
                                                    _: 1
                                                }),
                                                _createVNode(_component_van_col, { span: "18" }, {
                                                    default: _withCtx(function () { return [
                                                        _createTextVNode(_toDisplayString(item.orderPrice), 1)
                                                    ]; }),
                                                    _: 2
                                                }, 1024)
                                            ]; }),
                                            _: 2
                                        }, 1024),
                                        _createVNode(_component_van_row, { class: "order-field" }, {
                                            default: _withCtx(function () { return [
                                                _createVNode(_component_van_col, {
                                                    class: "order-field-title",
                                                    span: "6"
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_19
                                                    ]; }),
                                                    _: 1
                                                }),
                                                _createVNode(_component_van_col, { span: "18" }, {
                                                    default: _withCtx(function () { return [
                                                        _createTextVNode(_toDisplayString(item.testUserName), 1)
                                                    ]; }),
                                                    _: 2
                                                }, 1024)
                                            ]; }),
                                            _: 2
                                        }, 1024),
                                        _createVNode(_component_van_row, { class: "order-field" }, {
                                            default: _withCtx(function () { return [
                                                _createVNode(_component_van_col, {
                                                    class: "order-field-title",
                                                    span: "6"
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_20
                                                    ]; }),
                                                    _: 1
                                                }),
                                                _createVNode(_component_van_col, { span: "18" }, {
                                                    default: _withCtx(function () { return [
                                                        _createTextVNode(_toDisplayString(item.sampleCode), 1)
                                                    ]; }),
                                                    _: 2
                                                }, 1024)
                                            ]; }),
                                            _: 2
                                        }, 1024),
                                        _createVNode(_component_van_row, { class: "order-field" }, {
                                            default: _withCtx(function () { return [
                                                _createVNode(_component_van_col, {
                                                    class: "order-field-title",
                                                    span: "6"
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_21
                                                    ]; }),
                                                    _: 1
                                                }),
                                                _createVNode(_component_van_col, { span: "18" }, {
                                                    default: _withCtx(function () { return [
                                                        _createTextVNode(_toDisplayString(item.createTimeFormat), 1)
                                                    ]; }),
                                                    _: 2
                                                }, 1024)
                                            ]; }),
                                            _: 2
                                        }, 1024),
                                        ([12, 3, 6].includes(item.orderStatus) ||
                                            (item.hasBind === false &&
                                                item.orderStatus !== 10 &&
                                                item.orderStatus !== 2))
                                            ? (_openBlock(), _createBlock(_component_van_divider, {
                                                key: 0,
                                                dashed: ""
                                            }))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_22, [
                                            (item.hasBind === false &&
                                                [12, 3, 4].includes(item.orderStatus))
                                                ? (_openBlock(), _createBlock(_component_van_button, {
                                                    key: 0,
                                                    round: "",
                                                    color: "#3DABA4",
                                                    plain: "",
                                                    size: "small",
                                                    onClick: _withModifiers(function ($event) { return (_unref(router).push("/salesman-information-binding/?orderId=" + item.orderId + "&orderNo=" + item.orderNo)); }, ["stop"])
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_23
                                                    ]; }),
                                                    _: 2
                                                }, 1032, ["onClick"]))
                                                : _createCommentVNode("", true),
                                            (item.orderStatus === 3)
                                                ? (_openBlock(), _createBlock(_component_van_button, {
                                                    key: 1,
                                                    style: _normalizeStyle({ marginLeft: '0.2rem' }),
                                                    round: "",
                                                    plain: "",
                                                    size: "small",
                                                    onClick: _withModifiers(function ($event) { return (handleSkipExpress(item)); }, ["stop"])
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_24
                                                    ]; }),
                                                    _: 2
                                                }, 1032, ["style", "onClick"]))
                                                : _createCommentVNode("", true),
                                            ((item.orderStatus === 12 || item.orderStatus === 3) &&
                                                !item.sendStatus &&
                                                item.sendStatus !== 0)
                                                ? (_openBlock(), _createBlock(_component_van_button, {
                                                    key: 2,
                                                    style: _normalizeStyle({ marginLeft: '0.2rem' }),
                                                    round: "",
                                                    color: "#3DABA4",
                                                    plain: "",
                                                    size: "small",
                                                    onClick: _withModifiers(function ($event) { return (_unref(router).push("/salesman-sending-express?orderId=" + item.orderId)); }, ["stop"])
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_25
                                                    ]; }),
                                                    _: 2
                                                }, 1032, ["style", "onClick"]))
                                                : _createCommentVNode("", true),
                                            (item.sendStatus === 2)
                                                ? (_openBlock(), _createBlock(_component_van_button, {
                                                    key: 3,
                                                    style: _normalizeStyle({ marginLeft: '0.2rem' }),
                                                    round: "",
                                                    color: "#3DABA4",
                                                    plain: "",
                                                    size: "small",
                                                    onClick: _withModifiers(function ($event) { return (_unref(router).push("/salesman-sending-express?orderId=" + item.orderId + "&sendStatus=2")); }, ["stop"])
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_26
                                                    ]; }),
                                                    _: 2
                                                }, 1032, ["style", "onClick"]))
                                                : _createCommentVNode("", true),
                                            (item.orderStatus === 6)
                                                ? (_openBlock(), _createBlock(_component_van_button, {
                                                    key: 4,
                                                    style: _normalizeStyle({ marginLeft: '0.2rem' }),
                                                    round: "",
                                                    plain: "",
                                                    size: "small",
                                                    onClick: _withModifiers(function () {
                                                        reportUrl.value = item.reportUrl;
                                                        reportVisible.value = true;
                                                    }, ["stop"])
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_27
                                                    ]; }),
                                                    _: 2
                                                }, 1032, ["style", "onClick"]))
                                                : _createCommentVNode("", true),
                                            (!item.hasDepartDoctor)
                                                ? (_openBlock(), _createBlock(_component_van_button, {
                                                    key: 5,
                                                    style: _normalizeStyle({ marginLeft: '0.2rem' }),
                                                    round: "",
                                                    plain: "",
                                                    color: "#3DABA4",
                                                    size: "small",
                                                    onClick: _withModifiers(function ($event) { return (_unref(router).push("/salesman-departDoctor?orderId=" + item.orderId + "&hospitalId=" + item.hospitalId)); }, ["stop"])
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_28
                                                    ]; }),
                                                    _: 2
                                                }, 1032, ["style", "onClick"]))
                                                : _createCommentVNode("", true)
                                        ])
                                    ], 4)
                                ], 8, _hoisted_3));
                            }), 128))
                        ]; }),
                        _: 1
                    }, 8, ["style", "loading", "finished"])
                ]),
                (reportVisible.value)
                    ? (_openBlock(), _createBlock(ReviewReport, {
                        key: 0,
                        reportUrl: reportUrl.value,
                        onCancel: handleCancel
                    }, null, 8, ["reportUrl"]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
